import { createAsyncThunk } from '@reduxjs/toolkit';
import { updateOutreach } from '@/store/outreaches';

const getOutreachById = async ({ outreachId }, { extra: { http } }) => {
  try {
    const result = await http.get(`/outreaches/${outreachId}`);
    return result;
  } catch (e) {}
};

const getOutreachByIdInBackground = async (
  { outreachId },
  { extra: { http } }
) => {
  try {
    const result = await http.get(`/outreaches/${outreachId}`);
    return result;
  } catch (e) {}
};

const getOutreachStepById = async ({ stepId }, { extra: { http } }) => {
  try {
    const result = await http.get(`/steps/${stepId}`);
    return result;
  } catch (e) {}
};

const onStartOutreach = async (
  { outreach: { id } },
  { extra: { http }, dispatch }
) => {
  try {
    const result = await http.put(`/outreaches/${id}/activate`);
    dispatch(updateOutreach({ id, to: 'active' }));
    return result;
  } catch (e) {}
};

const onPauseOutreach = async (
  { outreach: { id } },
  { extra: { http }, dispatch }
) => {
  try {
    const result = await http.put(`/outreaches/${id}/pause`);
    dispatch(updateOutreach({ id, to: 'paused' }));
    return result;
  } catch (e) {}
};

const onResumeOutreach = async (
  { outreach: { id } },
  { extra: { http }, dispatch }
) => {
  try {
    const result = await http.put(`/outreaches/${id}/resume`);
    dispatch(updateOutreach({ id, to: 'active' }));
    return result;
  } catch (e) {}
};

const onCompleteOutreach = async (
  { outreach: { id } },
  { extra: { http }, dispatch }
) => {
  try {
    const result = await http.put(`/outreaches/${id}/complete`);
    dispatch(updateOutreach({ id, to: 'completed' }));
    return result;
  } catch (e) {}
};

const onPromoteOutreach = async (
  { outreach: { id }, name, description },
  { extra: { http } }
) => {
  try {
    const result = await http.put(`/outreaches/${id}/promote`, {
      name,
      description,
    });
    return result;
  } catch (e) {}
};

const onPreviewOutreachContent = async (
  { senderId, outreachId, subject, body, stepSeq },
  { extra: { http } }
) => {
  try {
    const result = await http.post('/templates/preview', {
      template: {
        sender_id: senderId,
        outreach_id: +outreachId,
        subject,
        body,
        step_seq: stepSeq,
      },
    });
    return result;
  } catch (e) {}
};

const onSendPreviewMail = async (
  { id, email, templateKey },
  { extra: { http } }
) => {
  try {
    const result = await http.post('/templates/send_preview', {
      template: {
        id,
        email,
        template_key: templateKey,
      },
    });
    return result;
  } catch (e) {}
};

const onFetchCandidates = async ({ outreachId, page }, { extra: { http } }) => {
  const params = {
    page,
  };

  try {
    const result = await http.get(`/outreaches/${outreachId}/candidates`, {
      params,
    });
    return result;
  } catch {}
};

const getOutreach = async ({ outreachId }, { extra: { http } }) => {
  try {
    const result = await http.get(`/outreaches/${outreachId}`);
    return result;
  } catch (e) {}
};

const createOutreach = async (payload, { extra: { http } }) => {
  try {
    const {
      title,
      trackClicks,
      trackOpens,
      schedule,
      input_collaborators,
      ats_job_id,
    } = payload;
    const result = await http.post('/outreaches', {
      outreach: {
        title: title,
        schedule: schedule,
        track_clicks: trackClicks,
        track_opens: trackOpens,
        input_collaborators: input_collaborators,
        ats_job_id: ats_job_id,
      },
    });
    return result;
  } catch (e) {}
};

const updateOutreachSettings = async (payload, { extra: { http } }) => {
  try {
    const {
      title,
      trackClicks,
      trackOpens,
      schedule,
      input_collaborators,
      outreachId,
      ats_job_id,
    } = payload;
    const result = await http.put(`/outreaches/${outreachId}`, {
      outreach: {
        title: title,
        schedule: schedule,
        track_clicks: trackClicks,
        track_opens: trackOpens,
        input_collaborators: input_collaborators,
        ats_job_id: ats_job_id,
      },
    });
    return result;
  } catch (e) {}
};

const cloneOutreach = async (payload, { extra: { http } }) => {
  try {
    const {
      title,
      trackClicks,
      trackOpens,
      schedule,
      input_collaborators,
      outreachId,
      ats_job_id,
    } = payload;
    const result = await http.post(`/outreaches/${outreachId}/clone`, {
      outreach: {
        title: title,
        schedule: schedule,
        track_clicks: trackClicks,
        track_opens: trackOpens,
        input_collaborators: input_collaborators,
        ats_job_id: ats_job_id,
      },
    });
    return result;
  } catch (e) {}
};

export const fetchOutreach = createAsyncThunk('outreach/fetch', getOutreach);

export const createScratchOutreach = createAsyncThunk(
  'outreach/create/new',
  createOutreach
);

export const updateOutreachSettingsDispatch = createAsyncThunk(
  'outreach/update',
  updateOutreachSettings
);

export const CloneOutreachDispatch = createAsyncThunk(
  'outreach/clone',
  cloneOutreach
);

export const fetchOutreachById = createAsyncThunk(
  'outreach/fetch/byId',
  getOutreachById
);

export const fetchOutreachByIdInBackground = createAsyncThunk(
  'outreach/fetch/byIdInBg',
  getOutreachByIdInBackground
);

export const fetchStepById = createAsyncThunk(
  'step/fetch/byId',
  getOutreachStepById
);

export const startOutreach = createAsyncThunk(
  'outreach/start',
  onStartOutreach
);

export const pauseOutreach = createAsyncThunk(
  'outreach/pause',
  onPauseOutreach
);

export const resumeOutreach = createAsyncThunk(
  'outreach/resume',
  onResumeOutreach
);

export const completeOutreach = createAsyncThunk(
  'outreach/complete',
  onCompleteOutreach
);

export const promoteOutreachToBlueprint = createAsyncThunk(
  'outreach/promote',
  onPromoteOutreach
);

export const getPreviewContent = createAsyncThunk(
  'outreach/previewContent',
  onPreviewOutreachContent
);

export const sendPreviewMail = createAsyncThunk(
  'outreach/sendPreview',
  onSendPreviewMail
);

export const fetchOutreachCandidates = createAsyncThunk(
  'outreach/candidates',
  onFetchCandidates
);
